module.exports = __webpack_public_path__ + "media/images/ln/constellation_06-1dd70ce2e1846a0afcd82d2123c0c125.png";